var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "notification has-background-grey-darker",
          attrs: { id: "help" },
        },
        [
          _c("b", [_vm._v(_vm._s(_vm.$t("help")))]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v(_vm._s(_vm.$t("help.click")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("help.timebar")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("help.layer")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("help.qgis")))]),
            _vm._v(" "),
            _vm.$conf.tilesets.layers.length > 0
              ? _c("li", [
                  _vm._v(_vm._s(_vm.$t("help.parcelts")) + " "),
                  _c("a", { attrs: { href: _vm.$t("help.parceltslink") } }, [
                    _vm._v(_vm._s(_vm.$t("help.parceltsapiname"))),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("help.ardapi")) + " "),
              _c("a", { attrs: { href: _vm.$t("help.ardapilink") } }, [
                _vm._v(_vm._s(_vm.$t("help.ardapiname"))),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("help.wmsexamples")) + " "),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: { click: _vm.openPlaygroundModal },
                },
                [_vm._v(_vm._s(_vm.$t("help.wmsexampleslink")))]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }